import { createStore, applyMiddleware, compose } from "redux";

// reducers
import rootReducers from "./reducers/rootReducer";

//
import thunk from "redux-thunk";

const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

const store = createStore(
  rootReducers,
  composeEnhancers(applyMiddleware(thunk))
);

export default store;
